import { useContext } from '@/compat';
import { ButtonColors, DialogColors } from '../../../components/dialogs/constants';

/**
 * This function returns a message to the user to confirm
 * @param {string} title - Message will be shown to user
 * @returns {function}
 * @example{
 *   const isConfirm = useConfirm("some message");
 *
 *   return{
 *     true: if the user accept
 *     false: if the user decline
 *   }
 * }
 */
const useConfirm = () => {
  const { $root } = useContext();

  const warning = () => async (title, message) => $root.$confirm(title, message, {
    color: DialogColors.WARNING,
    buttonColors: {
      accept: ButtonColors.WARNING,
      decline: ButtonColors.DEFAULT,
    },
  });

  const error = () => async (title, message) => $root.$confirm(title, message, {
    color: DialogColors.ERROR,
    buttonColors: {
      accept: ButtonColors.ERROR,
      decline: ButtonColors.DEFAULT,
    },
  });

  const success = () => async (title, message) => $root.$confirm(title, message, {
    color: DialogColors.SUCCESS,
    buttonColors: {
      accept: ButtonColors.SUCCESS,
      decline: ButtonColors.DEFAULT,
    },
  });

  const primary = () => async (title, message) => $root.$confirm(title, message, {
    color: DialogColors.PRIMARY,
    buttonColors: {
      accept: ButtonColors.PRIMARY,
      decline: ButtonColors.DEFAULT,
    },
  });

  const info = () => async (title, message) => $root.$confirm(title, message, {
    color: DialogColors.INFO,
    buttonColors: {
      accept: ButtonColors.INFO,
      decline: ButtonColors.DEFAULT,
    },
  });

  const close = () => $root.$closeConfirm();

  return {
    warning,
    error,
    primary,
    info,
    success,
    close,
  };
};

export default useConfirm;
